/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type sprintsCompletedComponent_viewer = {
    readonly insightComponentsData: {
        readonly sprintsCompleted: {
            readonly doneSprints: number | null;
            readonly remainingSprints: number | null;
        } | null;
    } | null;
    readonly " $refType": "sprintsCompletedComponent_viewer";
};
export type sprintsCompletedComponent_viewer$data = sprintsCompletedComponent_viewer;
export type sprintsCompletedComponent_viewer$key = {
    readonly " $data"?: sprintsCompletedComponent_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"sprintsCompletedComponent_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shareKey",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isProjectGroupType",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "sprintsCompletedComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "shareKey",
          "variableName": "shareKey"
        }
      ],
      "concreteType": "InsightComponentsDataType",
      "kind": "LinkedField",
      "name": "insightComponentsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "isProjectGroupType",
              "variableName": "isProjectGroupType"
            },
            {
              "kind": "Variable",
              "name": "projectId",
              "variableName": "projectId"
            }
          ],
          "concreteType": "SprintsCompleted",
          "kind": "LinkedField",
          "name": "sprintsCompleted",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "doneSprints",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingSprints",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '98f9b97b926d747816cddca74e45dd00';
export default node;
